import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/automations")({
  component: lazyRouteComponent(() => import("./+Automations")),
  head: () => ({
    meta: seo({ title: "Post Sales Messages" }),
  }),
});
